import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import 'assets/scss/subscriptionModal.css';

const SubscriptionModal = ({
  isVisible,
  toggleModal,
  confirmText,
  handleCancel,
  handleConfirm,
  noFooter,
  children,
}) => {
  const footerDisplay = noFooter ? 'd-none' : 'modal-footer pr-5 pl-5 pt-4 pb-4 bg-white';

  return (
    <Modal className="subscription-modal" visible={isVisible}>
      <div className="modal-header pl-3 pr-4">
        Manage your Soono Account
        <a
          onClick={e => {
            e.preventDefault();
            toggleModal();
          }}
          className="close-onboarding-modal"
        >
          <FontAwesomeIcon icon="times" />
        </a>
      </div>
      <div className="modal-body text-center">{children}</div>
      <div className={footerDisplay}>
        <div className="d-block m-auto">
          <button className="btn btn-lg btn-cancel-footer mr-3" onClick={handleCancel}>
            Nevermind
          </button>
          <button className="btn btn-lg btn-confirm" onClick={handleConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

SubscriptionModal.defaultProps = {
  isVisible: false,
  toggleModal: () => {},
  noFooter: false,
};

SubscriptionModal.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  confirmText: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  noFooter: PropTypes.bool,
};

export default SubscriptionModal;



// WEBPACK FOOTER //
// ./src/components/Modal/subscription/subscriptionModal.js